import { RefObject } from 'react';
import WaveSurfer from 'wavesurfer.js';
import type { WaveSurferOptions as WaveSurferOriginalOptions } from 'wavesurfer.js';

export type WaveSurferOptions = Omit<WaveSurferOriginalOptions, 'container'>;
export type WaveSurferRef = RefObject<WaveSurfer | undefined>;

export const AUDIO_VISUALISATIONS = ['waveform', 'spectrogram'] as const;
export type AudioVisualisation = (typeof AUDIO_VISUALISATIONS)[number];
